// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_up-0";